import type * as React from 'react';
import { put } from '@Domain/Api';
import type { OrganizationPayload } from '@Application/Organizations/Organizations/Actions/organizationsFetched';
import organizationUpdated, {
	type OrganizationUpdatedAction,
} from '@Application/Organizations/Organizations/Actions/organizationUpdated';
import organizationUpdateFailed, {
	type OrganizationUpdateFailedAction,
} from '@Application/Organizations/Organizations/Actions/organizationUpdateFailed';
import type UpdateOrganization from '@Application/Organizations/Organizations/Commands/UpdateOrganization';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationUpdatedAction | OrganizationUpdateFailedAction;

export default (command: UpdateOrganization) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<OrganizationPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/organizations/${command.organizationId}`,
				command.toJSON(),
			);

			const action = organizationUpdated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
